import { MessageDescriptor, useIntl } from "react-intl"

export function useConvertTranslatedLabel(options: { label: MessageDescriptor; value: unknown }[]) {
  const intl = useIntl()
  return options.map(({ label, value }) => ({ label: intl.formatMessage(label), value }))
}
